import React, { FC } from "react";

import { useFavouritesProviderContext } from "../../providers";
import { FavouriteItemType } from "../../types";

import { FavouritesSettingsBulkExport } from "./FavouritesSettingsBulkExport";
import { FavouritesSettingsMap } from "./FavouritesSettingsMap";
import { FavouritesSettingsSlide } from "./FavouritesSettingsSlide";

export const FavouritesSettings: FC = () => {
  const {
    state: { selectedFavouriteItem },
  } = useFavouritesProviderContext();

  switch (selectedFavouriteItem?.type) {
    case FavouriteItemType.Map:
      return <FavouritesSettingsMap key={selectedFavouriteItem.id} item={selectedFavouriteItem} />;
    case FavouriteItemType.Slide:
      return <FavouritesSettingsSlide key={selectedFavouriteItem.id} item={selectedFavouriteItem} />;
    case FavouriteItemType.BulkExport:
      return <FavouritesSettingsBulkExport key={selectedFavouriteItem.id} item={selectedFavouriteItem} />;
    case FavouriteItemType.SavedBulkExport:
      return <FavouritesSettingsBulkExport key={selectedFavouriteItem.id} item={selectedFavouriteItem} />;
    default:
      return null;
  }
};
